//We want to
/**
 * continously load new messages (strings, will be audio later)
 * allow switching station (enforce 5s cooldown)
 */

import { addEvent } from "./events";
import { Ally } from "./units";

export let radioUnit : Ally | null = null;




export function trySelectUnit(unit:Ally){
    radioUnit = unit;
    ambience.play();
    machinegun.play();
    staticloop.play();
}

//Sounds
const ambience = new Audio('artillery/sounds/ambience.mp3'); //always on ambience
ambience.loop = true;
const enemy = new Audio('artillery/sounds/enemyroar.wav'); //sound of enemy 'aliens'
const machinegun = new Audio('artillery/sounds/machinegunambience.wav'); //machine gun loop
machinegun.volume = 0.5;
// const plane = new Audio('artillery/sounds/plane_loop.wav'); //plane loop
const staticloop = new Audio('artillery/sounds/staticloop.wav'); //static loop
staticloop.volume = 0.5;

export function checkForMessages(){
    if(!radioUnit){
        setTimeout(checkForMessages, 16);
        return;
    }
    if(radioUnit.radioQueue.length == 0){
        setTimeout(checkForMessages, 16);
        return;
    }
    addEvent(radioUnit.radioQueue[0]);
    radioUnit.radioQueue.splice(0, 1);
    setTimeout(checkForMessages, 1000);
}

setInterval(() => {
    if(!radioUnit){return;}
    staticloop.playbackRate = 0;
    machinegun.playbackRate = 0;
    if(radioUnit.unit.health <= 0){
        staticloop.playbackRate = 1;
    }else if(radioUnit.unit.attack.target){
        machinegun.playbackRate = 1;
        if(Math.random() < 0.0003){
            enemy.play();
        }
    }
}, 100);